var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVisualiser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.5,
    height: 18.5,
    viewBox: "0 0 18.5 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-visualiser",
    transform: "translate(-120.376 -515.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_180",
    "data-name": "Trac\\xE9 180",
    d: "M137.626,524.748a8,8,0,1,1-2.559-5.865",
    fill: "none",
    stroke: "#445aa5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_108",
    "data-name": "Groupe 108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_181",
    "data-name": "Trac\\xE9 181",
    d: "M129.626,520.176a4.571,4.571,0,1,0,4.571,4.572A4.571,4.571,0,0,0,129.626,520.176Zm1.388,4.6a1.361,1.361,0,1,1,1.36-1.361A1.361,1.361,0,0,1,131.014,524.775Z",
    fill: "#445aa5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_182",
    "data-name": "Trac\\xE9 182",
    d: "M137.78,519.151v1.216a1.433,1.433,0,0,1-1.433,1.433h-1.215",
    fill: "none",
    stroke: "#e73c4c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisualiser);
export default __webpack_public_path__ + "static/media/icon-visualiser.d4ab82ec96492d9e4345e7dced14fa0f.svg";
export { ForwardRef as ReactComponent };